$(document).ready(function() {
$('.accordion-header').on('click', function() {
      if ($(window).width() < 1280) { // Apply only on mobile view
        $(this).toggleClass('active');
        $(this).next('.accordion-content').slideToggle(300);
      }
    });
  });

  
  // Ensure content stays open if screen is resized to desktop
  $(window).on('resize', function() {
    if ($(window).width() >= 1280) {
      $('.accordion-content').show();
      $('.accordion-header').removeClass('active');
    } else {
      $('.accordion-content').hide();
    }

});
